import { Heading, Loading } from '@workwhile/ui'
import { CompanyPosition } from 'api/company'
import { createContext } from 'lib/createContext'
import { useCompanyPosition } from 'queries/company'
import React, { PropsWithChildren, useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'
import { PositionIdInput } from './PositionIdInput'

interface PositionContextValueProps {
  positionId: number | null
  positionData?: CompanyPosition | null
  refetchPositionData: () => void
  isLoadingPositionData: boolean
}

export const [PositionEditorContext, usePositionEditorContext] =
  createContext<PositionContextValueProps>({
    name: 'PositionEditorContext',
  })

export function PositionEditorContextProvider({ children }: PropsWithChildren) {
  const [searchParams] = useSearchParams()
  const positionId = searchParams.get('positionId')
  const {
    data: positionData,
    isFetching: isLoadingPositionData,
    refetch: refetchPositionData,
  } = useCompanyPosition(positionId ? Number(positionId) : null)

  const value = useMemo(
    () => ({
      positionId: positionId ? Number(positionId) : null,
      positionData,
      refetchPositionData,
      isLoadingPositionData,
    }),
    [positionId, positionData, refetchPositionData, isLoadingPositionData]
  )

  return (
    <PositionEditorContext.Provider value={value}>
      <Heading level={2}>
        ✏️ Position {positionData?.isApproved ? 'Editor' : 'Approval'} Checklist
      </Heading>
      <PositionIdInput />
      {isLoadingPositionData ? <Loading /> : positionData ? children : null}
    </PositionEditorContext.Provider>
  )
}
